// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "skystatic/js/" + chunkId + "." + "6f7e77c7" + ".chunk.js";
};